/** Two letters for a client's mark: the first letters of its first two words ("OTIS EPC" → "OE"). */
export const clientInitials = (name: string): string => {
  const words = (name || '').replace(/[^\p{L}\p{N} ]+/gu, ' ').trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '?';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
};
